// HomePage.js
import React, { useState } from "react";
import PropTypes from "prop-types";

// Material UI components
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Divider from '@mui/material/Divider';
import makeStyles from '@mui/styles/makeStyles';

// Local components
import AccordionSummaryContent from "./AccordionSummaryContent";
import AccordionDetailsContent from "./AccordionDetailsContent";
import ResultToolbar from "./ResultToolbar";

// Styles
const useStyles = makeStyles({
  panelDetails: {
    borderTop: "1px solid #777777",
  },
  divider: {
    height: "80px",
  },
});

// Amplify theme overrides
const ampTheme = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
}

export default function Result({ result }) {
  const classes = useStyles();
  const [expand, setExpand] = useState(false);

  return (
    <Accordion 
      TransitionProps={{ unmountOnExit: true }}
      onChange={(event, expanded) => setExpand(expanded)}
    >
      <AccordionSummary
        expandIcon={null}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <AccordionSummaryContent result={result} />
        <Divider orientation="vertical" flexItem variant="middle" className={classes.divider}/>
          <ResultToolbar expand={expand} result={result} />
      </AccordionSummary>
      <AccordionDetails className={classes.panelDetails}>
        <AccordionDetailsContent result={result} />
      </AccordionDetails>
    </Accordion>
  );
}

Result.propTypes = {
    result: PropTypes.object,
};
